<script setup lang="ts">
const controls = inject(diKeys.mediaControls)
</script>

<template>
  <button @click="controls?.togglePlay()">
    <slot />
  </button>
</template>
